import React, { Component } from 'react';


class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        let tabs = []
        this.props.tabs.map((item, key) => {
            this.props.compete.customerSegmentData.map(comp => {
                comp.segments.map(segments => {
                    if (item.groupId === comp.groupId && item.segmentId === segments.segmentId) {
                        tabs.push(
                            <li className="nav-item" key={`${item.groupId + `id` + item.segmentId}`} onClick={()=>this.props.onTabChange(key)}>
                                <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" : "nav-link"} href={`#${item.groupId + `id` + item.segmentId}`} aria-controls={`${item.groupId + `id` + item.segmentId}`} aria-selected="true">{comp.groupName + ` - ` + segments.name}</a>
                            </li>)
                    }
                })
            })

        });
        let tabsContent = this.props.tabs.map((tabItem, key) => {
            return (
                <div id={tabItem.groupId + `id` + tabItem.segmentId} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv positioning-tab-content" : "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-xl-1 col-lg-2 col-md-3">
                            <strong>Pricing Position:</strong>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-4">
                            <div className="form-group">
                                <select className="form-control" value={tabItem.price ? tabItem.price : ''} onChange={(e)=>this.props.onChangePrice(tabItem.groupId,tabItem.segmentId,e.target.value)}>
                                    <option value="">Select One</option>
                                    <option value="Margin Maximization">Margin Maximization</option>
                                    <option value="Priced for Growth">Priced for Growth</option>
                                    <option value="Premium">Premium</option>
                                    <option value="Discount">Discount</option>
                                    <option value="Balanced Pricing">Balanced Pricing</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            )

        })
        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}

export default (Tabs);



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Step2/Tabs/Tabs.jsx